import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Download extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path
            d="M10.1,12.2V7.7H8.6v4.5L7,10.9L6,12l2.8,2.3c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2l2.8-2.3l-1-1.2
          L10.1,12.2z"
          />
          <path
            d="M14.8,5.3c-0.3-2.2-2.2-3.8-4.5-3.8c-1.6,0-3.1,0.8-3.9,2.2c-0.2,0-0.3,0-0.5,0c-1.8,0-3.3,1.5-3.3,3.3
          c0,0,0,0.1,0,0.1c-1,0.3-1.8,1.3-1.8,2.4c0,1.4,1.1,2.5,2.5,2.5h2v-1.5h-2c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h0.2l0.7-1
          C4.2,7.2,4.2,7.1,4.2,6.9c0-1,0.8-1.8,1.8-1.8c0.2,0,0.4,0,0.6,0.1l0.9-0.4C8,3.7,9.1,3,10.3,3c1.7,0,3.1,1.4,3.1,3.1l0.9,0.7
          c0.1,0,0.2,0,0.3,0c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8h-1.3v1.5h1.3c1.8,0,3.3-1.5,3.3-3.3C17.8,6.9,16.5,5.5,14.8,5.3z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Download.js